import { FilterConfiguration } from "@superset-ui/core";
import { Dispatch } from "redux";
import { triggerQuery } from "src/chart/chartAction";


import { setDashboardFilters } from "./dashboardState";

export const setTempFilter =
(filterConfig: FilterConfiguration,chartId: string,datasource:any) =>
async (dispatch: Dispatch, getState: () => any) => {
    if( !filterConfig ){
        return;
    }
  const oldFilters = getState()?.dashboardState?.tempFilters;
  const excludeCharts = new Set();
  const mergedFilterConfig = await filterConfig.map(filter => {
    const oldFilter = oldFilters[filter.id];
    // excludeCharts.add()
    if (!oldFilter) {
      return filter;
    }
    return { ...oldFilter, ...filter };
  });
  mergedFilterConfig.forEach(ele=>{
    ele.scope?.excluded.forEach((item:any) => excludeCharts.add(item))
  })
  try {
    //set mergerFIlterCOnfig using set disatch
    await (dispatch(setDashboardFilters(mergedFilterConfig)));
    for(let ele of Object.keys(getState().charts)){
        if([...excludeCharts].indexOf(parseInt(ele))===-1){
            if(datasource === getState().charts[ele].formData?.datasource){
                dispatch(triggerQuery(true,ele));
            }
        }
    }
  } catch (err) {
    console.log(err)
  }
};
export const extractFilter = (filterConfig: FilterConfiguration) => {

}
export const updateTempFilter =
(id: string,newDataMask: any,chartId: string,datasource:any) =>
async (dispatch: Dispatch, getState: () => any) => {
    if( !newDataMask ){
        return;
    }
  const oldFilters = getState()?.dashboardState?.tempFilters;
  const excludeCharts = new Set();
  // TODO extract this out when makeApi supports url parameters
  const mergedFilterConfig = oldFilters.map((filter:any) => {
    if (filter.id === id) {
        filter.defaultDataMask = newDataMask;
      return filter;
    }
    return { ...filter };
  }).filter((ele:any)=>{
    if(ele.defaultDataMask?.extraFormData.filters){
        // excludeCharts.add(ele.scope?.excluded[0])
        ele.scope?.excluded.forEach((item:any) => excludeCharts.add(item))
        return true
    }
    else{
        return false
    }
  });
  try {
    //set mergerFIlterCOnfig using set disatch
    await (dispatch(setDashboardFilters(mergedFilterConfig)));
    for(let ele of Object.keys(getState().charts)){
        if([...excludeCharts].indexOf(parseInt(ele))===-1){
            if(datasource === getState().charts[ele].formData?.datasource){
                dispatch(triggerQuery(true,ele));
            }
        }
    }
  } catch (err) {
    console.log(err)
  }
};